// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useCardStyles from "@store/Library/Widgets/Card/useCardStyles";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React from "react";
import styled from "styled-components";

const CardHeader = styled.div<InjectableCss>`${injectCss}}`;
export type CardHeaderStyles = InjectableCss;

export interface CardHeaderProps {
    extendedStyles?: CardHeaderStyles;
    overrideStyles?: CardHeaderStyles;
    className?: string;
}

const CardHeaderComponent: React.FC<CardHeaderProps> = ({ children, extendedStyles, overrideStyles, className }) => {
    const cardHeaderStyles = useCardStyles().header;
    const styles = useExpandProps(cardHeaderStyles, extendedStyles, overrideStyles);
    return (
        <CardHeader {...styles} className={className}>
            {children}
        </CardHeader>
    );
};

export default CardHeaderComponent;
